<template>
    <div :class="'rounded tit-txt font-weight-bold text-center ' + className">
        <div class="head-priamry" :style="'background-color:'+ bgColor +';'">
            <h5 class="color-white">
                {{tit}}
            </h5>
        </div>
        <div class="pa-20 pa-md-30 py-lg-34" style="background-color: #ebf5ff;">
            <h5><slot/></h5>
        </div>
    </div>
</template>

<script>

export default{
    props : {
        className : {type :String, default : ""},
        bgColor : {type :String, default : ""},
        tit : {type :String, default : ""},
    },
	components: {

	},
    data: () => {
        return {
        }
    },
	created() {
	},
	mounted() {
		this.init();
	},
	methods : {
		init : function() {
		}
	},
}
</script>

<style scoped>
</style>